import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
import { Building2, Car, Server, Code, Factory, Heart, Briefcase, ShoppingCart, Truck, BarChart3 } from 'lucide-react';
import './WhatWeDo.css';

const WhatWeDo = () => {
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const industries = [
    { name: 'Construction', icon: <Building2 size={32} />, color: '#FF6B6B' },
    { name: 'Automobile', icon: <Car size={32} />, color: '#4ECDC4' },
    { name: 'Data Centres', icon: <Server size={32} />, color: '#45B7D1' },
    { name: 'IT & Software', icon: <Code size={32} />, color: '#96CEB4' },
    { name: 'Manufacturing', icon: <Factory size={32} />, color: '#FFEAA7' },
    { name: 'Healthcare', icon: <Heart size={32} />, color: '#DFE6E9' },
    { name: 'Finance', icon: <Briefcase size={32} />, color: '#74B9FF' },
    { name: 'Retail', icon: <ShoppingCart size={32} />, color: '#A29BFE' },
    { name: 'Logistics', icon: <Truck size={32} />, color: '#FD79A8' },
    { name: 'Enterprise', icon: <BarChart3 size={32} />, color: '#FDCB6E' },
  ];

  return (
    <section className="whatwedo-section" id="industries" ref={ref} data-testid="whatwedo-section">
      <div className="container">
        <motion.div
          className="whatwedo-header"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.8 }}
        >
          <h2 className="section-title-white" data-testid="whatwedo-title">
            AI Built for Every Sector
          </h2>
          <p className="section-subtitle-white" data-testid="whatwedo-subtitle">
            At DanstonAI, we design and deploy industry-specific artificial intelligence systems that automate workflows, optimize operations, and eliminate repetitive human effort.
          </p>
        </motion.div>

        <div className="industries-grid">
          {industries.map((industry, index) => (
            <motion.div
              key={index}
              className="industry-card"
              initial={{ opacity: 0, y: 20 }}
              animate={inView ? { opacity: 1, y: 0 } : {}}
              transition={{ delay: index * 0.05, duration: 0.4, ease: 'easeOut' }}
              data-testid={`industry-${index}`}
            >
              <div className="industry-icon" style={{ color: industry.color }}>
                {industry.icon}
              </div>
              <h3 className="industry-name">{industry.name}</h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatWeDo;
